import { call, put } from 'redux-saga/effects';
import firebase from '../../firebase/firebase';
import { GET_HOME, GET_BRANDS, GET_PLANS } from '../../constants/constants';
import { setLoading, setRequestStatus } from '../actions/miscActions';
import {
  getHomeSuccess,
  getBrandsSuccess,
  getPlansSuccess
} from '../actions/homeActions';

function* initRequest() {
  yield put(setLoading(true));
  yield put(setRequestStatus(null));
}

function* handleError(e) {
  console.error(e);
  yield put(setLoading(false));
  yield put(setRequestStatus(e?.message || 'errorMessage1'));
}

function* homeSaga({ type, payload }) {
  switch (type) {
    case GET_HOME:
      try {
        yield initRequest();
        const result = yield call(firebase.getHomeObjects, payload);
        if (result.images.length === 0 || result.ads.length === 0) {
          handleError('errorMessage1');
        } else {
          yield put(
            getHomeSuccess({
              images: result.images,
              ads: result.ads
            })
          );
          yield put(setRequestStatus(''));
        }
        yield put(setLoading(false));
      } catch (e) {
        console.error(e);
        yield handleError(e);
      }
      break;
    case GET_BRANDS:
      try {
        yield initRequest();
        const result = yield call(firebase.getBrands, payload);

        if (result.brands.length === 0) {
          handleError('errorMessage1');
        } else {
          yield put(
            getBrandsSuccess({
              brands: result.brands
            })
          );
          yield put(setRequestStatus(''));
        }
        yield put(setLoading(false));
      } catch (e) {
        console.error(e);
        yield handleError(e);
      }
      break;
    case GET_PLANS:
      try {
        yield initRequest();
        const result = yield call(firebase.getPlans, payload);

        if (result.plans.length === 0) {
          handleError('errorMessage1');
        } else {
          yield put(
            getPlansSuccess({
              plans: result.plans
            })
          );
          yield put(setRequestStatus(''));
        }
        yield put(setLoading(false));
      } catch (e) {
        console.error(e);
        yield handleError(e);
      }
      break;
    default: {
      throw new Error(`Unexpected action type ${type}`);
    }
  }
}

export default homeSaga;
